export default [
    {
        key: 'settings.billing.positions.main',
        type: 'route',
        route: 'app.billing.positions.index',
        right: 'billing::position-list',
        children: [
            {
                key: 'settings.billing.positions.create',
                type: 'route',
                route: 'app.billing.positions.create',
                right: 'billing::position-create',
                showInNavigation: false,
                hideTabNav: true
            },
            {
                key: 'settings.billing.positions.details',
                type: 'placeholder',
                showInNavigation: false,
                hideTabNav: true,
                children: [
                    {
                        key: 'settings.billing.positions.edit',
                        type: 'route',
                        route: 'app.billing.positions.edit',
                        right: 'billing::position-create',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'settings.billing.position_categories.main',
        type: 'route',
        route: 'app.billing.position_categories.index',
        right: 'billing::position_category-list',
        children: [
            {
                key: 'settings.billing.position_categories.create',
                type: 'route',
                route: 'app.billing.position_categories.create',
                right: 'billing::position_category-create',
                showInNavigation: false,
                hideTabNav: true
            },
            {
                key: 'settings.billing.position_categories.details',
                type: 'placeholder',
                showInNavigation: false,
                hideTabNav: true,
                children: [
                    {
                        key: 'settings.billing.position_categories.edit',
                        type: 'route',
                        route: 'app.billing.position_categories.edit',
                        right: 'billing::position_category-create',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'settings.billing.invoice_templates.main',
        type: 'route',
        route: 'app.billing.invoice_templates.index',
        right: 'billing::invoice_template-list',
        children: [
            {
                key: 'settings.billing.invoice_templates.create',
                type: 'route',
                route: 'app.billing.invoice_templates.create',
                right: 'billing::invoice_template-create',
                showInNavigation: false,
                hideTabNav: true
            },
            {
                key: 'settings.billing.invoice_templates.details',
                type: 'placeholder',
                showInNavigation: false,
                hideTabNav: true,
                children: [
                    {
                        key: 'settings.billing.invoice_templates.edit',
                        type: 'route',
                        route: 'app.billing.invoice_templates.edit',
                        right: 'billing::invoice_template-edit',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'settings.billing.number_circles.main',
        type: 'route',
        route: 'app.billing.number-circles.index',
        right: 'billing::number_circle-list',
        children: [
            {
                key: 'settings.billing.number_circles.create',
                type: 'route',
                route: 'app.billing.number-circles.create',
                right: 'billing::number_circle-create',
                showInNavigation: false,
                hideTabNav: true
            },
            {
                key: 'settings.billing.number_circles.details',
                type: 'placeholder',
                showInNavigation: false,
                hideTabNav: true,
                children: [
                    {
                        key: 'settings.billing.number_circles.edit',
                        type: 'route',
                        route: 'app.billing.number-circles.edit',
                        right: 'billing::number_circle-edit',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'settings.billing.exports',
        type: 'route',
        route: 'app.exports.billing',
        right: 'exports::billing'
    }
];



// WEBPACK FOOTER //
// ./src/app/modules/navigation/resources/sub/billing.js